<template>
  <div class="page-content">
    <!-- ABRE MODAL LEGAJO -->
    <div id="info_legajo" style="overflow-y:scroll;" :style="{ display: currentLegajoDetails ? 'block' : 'none' }">
      <div id="header_legajo">
        <button
          id="cerrar_legajo"
          style="position: absolute; right: 20px; margin-top: 3px; background-color: red; font-weight: bold; color: #fff;"
          @click="closeLegajoModal"
        >
          CERRAR INFORME
        </button>
      </div>
      <table width="100%">
        <tr>
          <td width="210px">
            <center style="padding: 10px;">
              <div id="legajo_foto">
                <img v-if="currentLegajoDetails && currentLegajoDetails.avatar && currentLegajoDetails.avatar !== '-'"
                     :src="currentLegajoDetails.avatar"
                     alt="Profile Photo"
                     width="300px"
                     height="300px"
                     style="object-fit:cover; border-radius: 50%;" />
                <img v-else
                     src="https://thumbs.dreamstime.com/b/perfil-de-usuario-vectorial-avatar-predeterminado-179376714.jpg"
                     alt="Default Profile Photo"
                     width="300px"
                     height="300px"
                     style="object-fit:cover; border-radius: 50%;" />
              </div>
            </center>
          </td>
          <td valign="top" style="padding: 10px;">
            <table width="100%">
              <tr><td width="200px">Nombre y Apellido</td><td>{{ currentLegajoDetails?.nombre }} {{ currentLegajoDetails?.apellido }}</td></tr>
              <tr><td>DNI</td><td>{{ currentLegajoDetails?.dni }}</td></tr>
              <tr><td>Fecha de Nacimiento</td><td>{{ currentLegajoDetails?.nacimiento }}</td></tr>
              <tr><td>Fecha de Ingreso</td><td>{{ currentLegajoDetails?.ingreso }}</td></tr>
              <tr><td>Categoría</td><td>{{ currentLegajoDetails?.categoria }}</td></tr>
              <tr><td>Domicilio</td><td>{{ currentLegajoDetails?.domicilio || '-' }}</td></tr>
              <tr><td>Provincia</td><td>{{ currentLegajoDetails?.provincia || '-' }}</td></tr>
              <tr><td>Ciudad</td><td>{{ currentLegajoDetails?.ciudad || '-' }}</td></tr>
              <tr><td>Nacionalidad</td><td>{{ currentLegajoDetails?.nacionalidad || '-' }}</td></tr>
              <tr><td>Tel. Celular</td><td>{{ currentLegajoDetails?.tel_celular || '-' }}</td></tr>
              <tr><td>Email</td><td>{{ currentLegajoDetails?.email || '-' }}</td></tr>
            </table>
          </td>
          <td width="700px" valign="top" style="padding: 10px;">
            <table width="100%">
              <tr>
                <td align="center">DIAS TRABAJADOS</td>
                <td align="center">VACUNAS</td>
                <td align="center">CMA</td>
              </tr>
              <tr>
                <td align="center"><div class="circulo">{{ daysWorked }}</div></td>
                <td align="center"><div class="circulo">{{ currentLegajoDetails?.dosis || '0' }}</div></td>
                <td align="center"><div class="circulo">{{ currentLegajoDetails?.manipulador_vto || '-' }}</div></td>
              </tr>
            </table>
            <br/><br/>
            <table width="100%">
              <tr><td width="200px">ÚLTIMA OPERACIÓN</td><td>{{ lastOperationRoot }}</td></tr>
             
            </table>
          </td>
        </tr>
      </table>
      <!-- TABLA DE NOVEDADES -->
      <div style="margin-top:30px;">
        <table
          id="novedades_legajo"
          class="table table-theme table-row v-middle"
          data-plugin="dataTable"
        >
          <thead>
            <tr>
              <th><span class="text-muted">Status</span></th>
              <th><span class="text-muted">legajo</span></th>
              <th><span class="text-muted">Nombre</span></th>
              <th><span class="text-muted">Operación</span></th>
              <th><span class="text-muted">Novedad</span></th>
              <th><span class="text-muted">Detalle</span></th>
              <th><span class="text-muted">Horas</span></th>
              <th><span class="text-muted">Desde</span></th>
              <th><span class="text-muted">Hasta</span></th>
              <th><span class="text-muted">Días</span></th>
              <th><span class="text-muted">Destino</span></th>
              <th><span class="text-muted">Responsable</span></th>
              <th><span class="text-muted">Doc</span></th>
             
              
            </tr>
          </thead>
          <tbody>
            <tr v-for="caso in novedades" :key="caso.fireId">
              <!-- Badge según status -->
              <td>
                <span
                  v-if="caso.status==='En espera'"
                  class="badge text-uppercase badge-warning"
                >{{ caso.statusMensaje }}</span>
                <span
                  v-else-if="caso.status==='Resuelto'"
                  class="badge text-uppercase badge-success"
                >{{ caso.statusMensaje }}</span>
                <span
                  v-else-if="caso.status==='Observado'"
                  class="badge text-uppercase badge-info"
                >{{ caso.statusMensaje }}</span>
                <span
                  v-else-if="caso.status==='Rechazado'"
                  class="badge text-uppercase badge-danger"
                >{{ caso.statusMensaje }}</span>
                <span v-else class="badge text-uppercase badge-warning">En espera</span>
              </td>
              <td class="text-sm text-wrap">{{ caso.legajo }}</td>
              <td class="text-sm text-wrap">{{ caso.nombre }}</td>
              <td class="text-sm text-wrap">{{ caso.operacion_raiz }}</td>
              <td class="text-sm text-wrap">{{ caso.novedad }}</td>
              <td class="text-sm text-wrap">{{ caso.detalle }}</td>
              <td class="text-sm text-wrap">{{ caso.horas }}</td>
              <td class="text-sm text-wrap">{{ caso.desde }}</td>
              <td class="text-sm text-wrap">{{ caso.hasta }}</td>
              <td class="text-sm text-wrap">{{ caso.dias }}</td>
              <td class="text-sm text-wrap">{{ caso.destino }}</td>
              <td class="text-sm text-wrap">{{ caso.responsable }}</td>
              <td class="text-sm text-wrap">
                <button
                  v-if="caso.certificado !== '-' && caso.certificado !== 'yes' && caso.certificado !== 'not'"
                  type="button"
                  class="btn btn-secondary btn-xs ml-2"
                  @click.stop.prevent="openCertificate(caso.certificado)"
                >Ver Certificado</button>
                <span v-else>-</span>
              </td>
              
             
            </tr>
          </tbody>
        </table>
      </div>
      <!-- CIERRA TABLA DE NOVEDADES -->
    </div>
    <!-- CIERRA MODAL LEGAJO -->
    <!-- BREADCRUMB Y FILTROS -->
    <nav class="page-breadcrumb" id="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">{{ breadcrumbA }}</li>
        <li class="breadcrumb-item active" aria-current="page">{{ breadcrumbB }}</li>
      </ol>
    </nav>
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <h6 class="card-title"><i class="link-icon" data-feather="box"></i> {{ breadcrumbB }}</h6>
            <p class="card-description">{{ descripcion }}</p>
            <div class="w-50 d-flex align-items-center">
              <select class="custom-select mr-2" id="mes" v-model="selectedMonth">
                <option v-for="mes in meses" :key="mes.codigo" :value="mes.codigo">
                  {{ mes.nombre }}
                </option>
              </select>
              <select id="anio" class="custom-select mr-2" v-model="selectedYear">
                <option v-for="anio in anios" :key="anio" :value="anio">{{ anio }}</option>
              </select>
              <select id="tipo" class="custom-select mr-2" v-model="selectedType">
                <option value="alta">INGRESOS</option>
                <option value="baja">EGRESOS</option>
              </select>
              <button
                class="btn btn-success"
                id="consultarbaja"
                @click="obtenerPersonal()"
              >Consultar</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- LISTA DE CARGA -->
    <lista-carga v-if="triggers.load"></lista-carga>
    <!-- TABLA PRINCIPAL -->
    <div class="row" v-else>
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <table id="empresas" class="table">
                <thead>
                  <tr>
                    <th>Perfil</th>
                    <th>Cod</th>
                    <th>Legajo</th>
                    <th>Nombre</th>
                    <th>Fec. Nacimiento</th>
                    <th>CUIL</th>
                    <th>Empleado por</th>
                    <th>Ingreso</th>
                    <th>Egreso</th>
                    <th>Categoria</th>
                    <th>Operación</th>
                    <th>Empresa Madre</th>
                    <th>Tipo</th>
                    <th>Zonal</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="personalItem in personal"
                    :key="personalItem.legajo"
                    :class="{'fila-no-distribuido': personalItem.cod === '-'}"
                  >
                    <td v-if="personalItem.avatar==='-'" style="color:#fff;">
                      <img
                        width="40px"
                        height="40px"
                        style="border:1px solid #8b8b8b99; object-fit:cover"
                        src="https://thumbs.dreamstime.com/b/perfil-de-usuario-vectorial-avatar-predeterminado-179376714.jpg"
                        alt="Default Profile Avatar"
                      />
                    </td>
                    <td v-else style="color:#fff;">
                      <img
                        width="40px"
                        height="40px"
                        style="object-fit:cover"
                        :src="personalItem.avatar"
                        alt="Profile Avatar"
                      />
                    </td>
                    <td>{{ personalItem.bejerman }}</td>
                    <td>
                      <a href="#" @click.prevent="getLegajo(personalItem.legajo)">
                        {{ personalItem.legajo }}
                      </a>
                    </td>
                    <td>{{ personalItem.apellido }} <br/> {{ personalItem.nombre }}</td>
                    <td>{{ personalItem.nacimiento }}</td>
                    <td>{{ personalItem.cuil }}</td>
                    <td v-if="personalItem.razonsocial==='Food Service America'">
                      <span class="badge badge-success">Food Service America</span>
                    </td>
                    <td v-else>
                      <span class="badge badge-info">Food Service Catering</span>
                    </td>
                    <td>{{ personalItem.ingreso }}</td>
                    <td>{{ personalItem.egreso }}</td>
                    <td>{{ personalItem.categoria }}</td>
                    <td>{{ personalItem.operacion }}</td>
                    <td v-if="personalItem.madre==='Food Service America'">
                      <span class="badge badge-success">Food Service America</span>
                    </td>
                    <td v-else-if="personalItem.madre==='Food Service Catering'">
                      <span class="badge badge-info">Food Service Catering</span>
                    </td>
                    <td v-else>
                      <span class="badge badge-danger">Planta</span>
                    </td>
                    <td>{{ personalItem.tipo }}</td>
                    <td>{{ personalItem.zonal }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- MODALES -->
    <modal-administrar
      v-if="modalAdministrar.open"
      :empresa="modalOperacionId"
      :legajoEmpleado="modalAdministrar.legajo"
      :nombreEmpleado="modalAdministrar.nombre"
      :apellidoEmpleado="modalAdministrar.apellido"
      :operacion="modalAdministrar.operacion"
      :idDistribucion="modalAdministrar.idDistribucion"
      @cerrar-modal-asignar="refrescarPersonal($event)"
    ></modal-administrar>
    <modal-observar
      v-if="modalObservar.open"
      :dniEmpleado="modalObservar.dni"
      :legajoEmpleado="modalObservar.legajo"
      :nombreEmpleado="modalObservar.nombre"
      :apellidoEmpleado="modalObservar.apellido"
      @cerrar-modal-observar="refrescarPersonal($event)"
      @keyup.enter="closeModal('modalObservar')"
    ></modal-observar>
    <modal-vacunas
      v-if="modalVacunas.open"
      :dniEmpleado="modalVacunas.dni"
      :legajoEmpleado="modalVacunas.legajo"
      :nombreEmpleado="modalVacunas.nombre"
      :apellidoEmpleado="modalVacunas.apellido"
      :certificadoEmpleado="modalVacunas.certificado"
      @cerrar-modal-observar="refrescarPersonal($event)"
      @keyup.enter="closeModal('modalVacunas')"
    ></modal-vacunas>
    <modal-legales
      v-if="modalLegales.open"
      :dniEmpleado="modalLegales.dni"
      :nombreEmpleado="modalLegales.nombre"
      :apellidoEmpleado="modalLegales.apellido"
      :legajoEmpleado="modalLegales.legajo"
      @cerrar-modal-legales="refrescarPersonal($event)"
    ></modal-legales>

    <!-- New Observation Detail Modal -->
    <div v-if="modalObservacionDetalle.open" class="modal-overlay">
      <div class="modal-content">
        <h3 class="modal-title">Detalle de Observación</h3>
        <p class="modal-body">{{ modalObservacionDetalle.text }}</p>
        <button class="btn btn-danger" @click="closeModal('modalObservacionDetalle')">Cerrar</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import moment from 'moment'; // Explicitly import moment
require('datatables.net');
require('datatables.net-buttons/js/buttons.colVis.js')();
require('datatables.net-buttons/js/buttons.html5.js')();
require('datatables.net-buttons/js/buttons.flash.js')();
require('datatables.net-buttons/js/buttons.print.js')();

import ListaCarga from '../ListaCarga.vue';
import ModalAdministrar from './ModalAdministrar.vue';
import ModalObservar from './ModalObservar.vue';
import modalVacunas from './ModalVacunas.vue';
import ModalLegales from './ModalLegales';

const userPermission = JSON.parse(sessionStorage.getItem('userPermisos'));

export default {
  name: 'Historico',
  components: {
    ListaCarga,
    ModalAdministrar,
    ModalObservar,
    modalVacunas,
    ModalLegales
  },
  data() {
    return {
      breadcrumbA: 'Inicio',
      breadcrumbB: 'Personal',
      descripcion: 'En este modulo usted podra visualizar y administrar todo el personal de la empresa',
      triggers: { load: false },
      personal: [],
      novedades: [],
      meses: [
        { codigo: "01", nombre: "Enero" }, { codigo: "02", nombre: "Febrero" }, { codigo: "03", nombre: "Marzo" },
        { codigo: "04", nombre: "Abril" }, { codigo: "05", nombre: "Mayo" }, { codigo: "06", nombre: "Junio" },
        { codigo: "07", nombre: "Julio" }, { codigo: "08", nombre: "Agosto" }, { codigo: "09", nombre: "Septiembre" },
        { codigo: "10", nombre: "Octubre" }, { codigo: "11", nombre: "Noviembre" }, { codigo: "12", nombre: "Diciembre" }
      ],
      anios: [],
      selectedMonth: moment().format("MM"), // Set default to current month
      selectedYear: moment().format("YYYY"), // Set default to current year
      selectedType: 'alta', // Default type
      modalObservar: { open: false, dni: null, nombre: null, apellido: null, legajo: null },
      modalVacunas: { open: false, dni: null, nombre: null, apellido: null, legajo: null, certificado: null },
      modalAdministrar: { open: false, legajo: null, nombre: null, apellido: null, operacion: null, idDistribucion: null },
      modalLegales: { open: false, dni: null, nombre: null, apellido: null, legajo: null },
      currentLegajoDetails: null, // To store details of the selected legajo for the modal
      modalObservacionDetalle: { open: false, text: '' }, // New state for observation detail modal
      observacionesData: {}, // To store observations fetched from API
    };
  },
  computed: {
    daysWorked() {
      if (!this.currentLegajoDetails || !this.currentLegajoDetails.ingreso || this.currentLegajoDetails.ingreso === '-') return '-';
      const ingresoDate = moment(this.currentLegajoDetails.ingreso, "YYYY-MM-DD");
      const today = moment();
      return today.diff(ingresoDate, 'days');
    },
    lastOperationRoot() {
      if (!this.novedades || this.novedades.length === 0) return '-';
      // Sort by date (assuming 'fecha' or 'fecha_novedad' is the date field)
      // Let's assume 'fecha_novedad' is the most reliable date for novelty.
      const sortedNovedades = [...this.novedades].sort((a, b) => {
        const dateA = moment(a.fecha_novedad || a.fecha, "YYYY-MM-DD");
        const dateB = moment(b.fecha_novedad || b.fecha, "YYYY-MM-DD");
        return dateB.diff(dateA); // Descending order
      });
      return sortedNovedades[0].operacion_raiz || '-';
    }
  },
  methods: {
    isEditor(modulo) {
      if (userPermission.find(record => record.ModulosAccess === modulo)) {
        return userPermission
          .find(record => record.ModulosAccess === modulo)
          .Editor;
      } else {
        return false;
      }
    },
    closeModal(modalName) {
      this[modalName].open = false;
    },
    closeLegajoModal() {
      $("#info_legajo").slideUp();
      this.currentLegajoDetails = null; // Clear details when closing
      // Destroy DataTable for novedades_legajo if it exists
      if ($.fn.DataTable.isDataTable('#novedades_legajo')) {
        $('#novedades_legajo').DataTable().destroy();
      }
      this.novedades = []; // Clear novedades
    },
    observarPersonalId(dni, nombre, apellido, legajo) {
      this.modalObservar.dni = dni;
      this.modalObservar.nombre = nombre;
      this.modalObservar.apellido = apellido;
      this.modalObservar.legajo = legajo;
      setTimeout(() => {
        this.modalObservar.open = true;
      }, 200);
    },
    vacunas(dni, nombre, apellido, legajo, certificado) {
      this.modalVacunas.dni = dni;
      this.modalVacunas.nombre = nombre;
      this.modalVacunas.apellido = apellido;
      this.modalVacunas.legajo = legajo;
      if (certificado != null) {
        this.modalVacunas.certificado = certificado;
      }
      setTimeout(() => {
        this.modalVacunas.open = true;
      }, 200);
    },
    abrirModalAdministrar(legajo, nombre, apellido, operacion, idDistibucion, empleade) {
      this.modalAdministrar.legajo = legajo;
      this.modalAdministrar.nombre = nombre;
      this.modalAdministrar.apellido = apellido;
      this.modalAdministrar.operacion = operacion === '-' ? undefined : operacion;
      this.modalAdministrar.idDistribucion = idDistibucion;
      this.modalAdministrar.open = true;
    },
    abrirModalLegales(dni, nombre, apellido, legajo) {
      this.modalLegales.dni = dni;
      this.modalLegales.nombre = nombre;
      this.modalLegales.apellido = apellido;
      this.modalLegales.legajo = legajo;
      this.modalLegales.open = true;
    },
    openCertificate(url) {
      if (url && url !== '-') {
        window.open(url, '_blank');
      } else {
        alert('No hay certificado disponible.');
      }
    },
    showObservation(caso) {
      let observationText = 'No se encontró el detalle de la observación.';

      if (caso.observacion && typeof caso.observacion === 'object') {
        // If caso.observacion is an object, find the latest entry
        const nestedObservations = Object.values(caso.observacion);
        if (nestedObservations.length > 0) {
          const latestObservation = nestedObservations.sort((a, b) => {
            return moment(b.timestamp).diff(moment(a.timestamp));
          })[0];
          observationText = latestObservation.detalle || 'Detalle no disponible.';
        }
      } else if (caso.detalle && caso.detalle !== '-') {
        // Fallback to caso.detalle if caso.observacion is not an object
        observationText = caso.detalle;
      } else if (caso.obs && this.observacionesData[caso.legajo_numdoc]) { // Assuming legajo_numdoc is the DNI
        // Fallback to general observations data if available and obs flag is true
        observationText = this.observacionesData[caso.legajo_numdoc].observacion || this.observacionesData[caso.legajo_numdoc].detalle || observationText;
      }

      this.modalObservacionDetalle.text = observationText;
      this.modalObservacionDetalle.open = true;
    },
    async obtenerPersonal() {
      // Destroy existing DataTable instance before fetching new data
      if ($.fn.DataTable.isDataTable('#empresas')) {
        $('#empresas').DataTable().destroy();
      }

      let mes = this.selectedMonth;
      let anio = this.selectedYear;
      let tipo = this.selectedType;
      let fechas = this.obtenerFechasDelRango(mes, anio);
      var today = new Date(fechas[1]);
      var d = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      if (tipo === "baja") {
        d.setDate(d.getDate() - 28);
      }
      var me = d.getMonth() + 1;
      var mese = me < 10 ? "0" + me : me;
      var diae = d.getDate();
      diae = diae < 10 ? "0" + diae : diae;
      var principio = d.getFullYear() + "-" + mese + "-" + diae;
      var mesanio = anio + "-" + mes;
      this.triggers.load = true;

      const axiosrequest1 = axios.get('https://consumos.foodservice.com.ar/api/empresas');
      const axiosrequest2 = axios.get('https://apprrhh-707b9.firebaseio.com/personal.json?orderBy="$key"&limitToLast=7000&print=pretty');
      const axiosrequest3 = axios.get(`https://auth.foodservice.com.ar/?type=bajas_historico&desde=${principio}&hasta=${principio}&access_token=1234567`);
      const axiosrequest4 = axios.get('https://aplicativos.firebaseio.com/zonal.json?print=pretty');
      const axiosrequest5 = axios.get('https://aplicativos.firebaseio.com/categorias.json?print=pretty');
      const axiosrequest6 = axios.get('https://aplicativos.firebaseio.com/legales.json?print=pretty');
      const axiosrequest7 = axios.get('https://aplicativos.firebaseio.com/sectores.json?print=pretty');
      const axiosrequest8 = axios.get('https://apprrhh-707b9.firebaseio.com/personal_cat.json?orderBy="$key"&limitToLast=7000&print=pretty');
      const axiosrequest9 = axios.get('https://aplicativos.firebaseio.com/observacion_personal.json?print=pretty');
      const axiosrequest10 = axios.get('https://aplicativos.firebaseio.com/manipulacion.json?print=pretty');
      const axiosrequest11 = axios.get('https://aplicativos.firebaseio.com/certificado_vacunacion.json?print=pretty');
      const axiosrequest12 = axios.get('https://aplicativos.firebaseio.com/vacunas_personal.json?print=pretty');
      const axiosrequest13 = axios.get('https://aplicativos.firebaseio.com/perfil.json?print=pretty');

      try {
        const [
          operaciones, personal, distribucion, zonal, categorias,
          legales, sectores, personal_cat, observaciones,
          manipulacion, vacunacion, dosis, avatar
        ] = await axios.all([
          axiosrequest1, axiosrequest2, axiosrequest3, axiosrequest4,
          axiosrequest5, axiosrequest6, axiosrequest7, axiosrequest8,
          axiosrequest9, axiosrequest10, axiosrequest11, axiosrequest12,
          axiosrequest13
        ]);

        this.observacionesData = observaciones.data; // Store observations data

        let lista = [];
        const reemplazarIndefinido = s => (s === undefined || s === null || s === '') ? "-" : s;
        const reemplazarIndefinidoDosis = s => (s === undefined || s === null || s === '') ? "0" : s;

        const result_categoria = id => {
          let nombre = "";
          $.each(categorias.data, (k, v) => {
            if (v.codigo == id) nombre = v.nombre;
          });
          return nombre;
        };
        const result_distribucion = id => {
          let distri = "";
          $.each(distribucion.data, (clave, value) => {
            $.each(value, (k, v) => {
              if (v.legajo == id) {
                distri = { operacion: clave, idDistribucion: k };
              }
            });
          });
          return distri;
        };
        const result_operacion = id => {
          let operacion = "";
          Object.keys(sectores.data).forEach(sector => {
            if (sectores.data[sector].id_empresa == id) {
              operacion = sectores.data[sector].operacion;
            }
          });
          if (!operacion) {
            $.each(operaciones.data, (clave, value) => {
              if (value.id == id) operacion = value.name;
            });
          }
          return operacion;
        };
        const result_madre = id => {
          let madre = "";
          Object.keys(sectores.data).forEach(sector => {
            if (sectores.data[sector].id_empresa == id) madre = "-";
          });
          if (madre === "") {
            $.each(operaciones.data, (clave, value) => {
              if (value.id == id) madre = value.empresa_madre;
            });
          }
          return madre;
        };
        const result_tipo = id => {
          let tipoEmp = "";
          Object.keys(sectores.data).forEach(sector => {
            if (sectores.data[sector].id_empresa == id) tipoEmp = "Planta Central";
          });
          if (!tipoEmp) {
            $.each(operaciones.data, (clave, value) => {
              if (value.id == id) tipoEmp = value.tipo_empresa;
            });
          }
          return tipoEmp;
        };
        const result_operacion_bejerman = id => {
          let op = "";
          Object.keys(sectores.data).forEach(sector => {
            if (sectores.data[sector].id_empresa == id) {
              op = 'S' + sectores.data[sector].id;
            }
          });
          if (!op) {
            $.each(operaciones.data, (clave, value) => {
              if (value.id == id) op = value.catering_id;
            });
          }
          return op;
        };
        const result_apropiacion = id => {
          let apr = "";
          Object.keys(sectores.data).forEach(sector => {
            if (sectores.data[sector].id_empresa == id) apr = sectores.data[sector].id_empresa;
          });
          if (!apr) {
            $.each(operaciones.data, (clave, value) => {
              if (value.id == id) apr = value.id;
            });
          }
          return apr;
        };
        const result_zonal = id => {
          let zn = "";
          $.each(zonal.data, (clave, value) => {
            if (clave == id) zn = value.nombre;
          });
          return zn;
        };
        const result_manipulador = dni => {
          let link = "";
          $.each(manipulacion.data, (clave, value) => {
            if (clave == dni) link = value.link;
          });
          return link;
        };
        const result_manipulador_vto = dni => {
          let vto = "";
          $.each(manipulacion.data, (clave, value) => {
            if (clave == dni) vto = value.vto;
          });
          return vto;
        };
        const result_vacunacion = legajo => {
          let cert = "";
          $.each(vacunacion.data, (clave, value) => {
            if (clave == legajo) cert = value.certificado;
          });
          return cert;
        };
        const result_dosis = dni => {
          let count = "";
          $.each(dosis.data, (clave, value) => {
            if (clave == dni) count = Object.keys(value).length / 2;
          });
          return count;
        };
        const result_avatar = dni => {
          let img = "";
          $.each(avatar.data, (clave, value) => {
            if (clave == dni) img = value.imagen;
          });
          return img;
        };

        // Helper to process personal data
        const processPersonalData = (data, companyName) => {
          $.each(data, (clave, valor) => {
            let observ = observaciones.data[valor.leg_numdoc] !== undefined;
            let egreso = "-";
            if (valor.leg_fecegr != null) {
              egreso = reemplazarIndefinido(valor.leg_fecegr.date.replace(" 00:00:00.000000", ""));
            }
            let distribucion = result_distribucion(valor.leg_numero);

            const commonData = {
              cod: reemplazarIndefinido(result_apropiacion(distribucion.operacion)),
              razonsocial: companyName,
              bejerman: reemplazarIndefinido(result_operacion_bejerman(distribucion.operacion)),
              legajo: reemplazarIndefinido(valor.leg_numero),
              nombre: reemplazarIndefinido(valor.leg_nombre),
              apellido: reemplazarIndefinido(valor.leg_apellido),
              ingreso: reemplazarIndefinido(valor.leg_fecing.date.replace(" 00:00:00.000000", "")),
              egreso: egreso,
              categoria: reemplazarIndefinido(result_categoria(valor.cat_codigo)),
              nacimiento: reemplazarIndefinido(valor.leg_fecnac.date.replace(" 00:00:00.000000", "")),
              cuil: reemplazarIndefinido(valor.leg_cuil),
              operacion: reemplazarIndefinido(result_operacion(distribucion.operacion)),
              madre: reemplazarIndefinido(result_madre(distribucion.operacion)),
              tipo: reemplazarIndefinido(result_tipo(distribucion.operacion)),
              idDistribucion: distribucion.idDistribucion,
              zonal: reemplazarIndefinido(result_zonal(distribucion.operacion)),
              dni: valor.leg_numdoc,
              observacion: observ,
              manipulador: reemplazarIndefinido(result_manipulador(valor.leg_numdoc)),
              manipulador_vto: reemplazarIndefinido(result_manipulador_vto(valor.leg_numdoc)),
              vacunado: reemplazarIndefinido(result_vacunacion(valor.leg_numero)),
              dosis: reemplazarIndefinidoDosis(result_dosis(valor.leg_numdoc)),
              avatar: reemplazarIndefinido(result_avatar(valor.leg_numdoc)),
              // Datos personales adicionales
              domicilio: reemplazarIndefinido(valor.leg_domic),
              provincia: reemplazarIndefinido(valor.leg_prvdom), // Código de provincia
              ciudad: reemplazarIndefinido(valor.leg_locali), // Código de localidad
              nacionalidad: reemplazarIndefinido(valor.nacionalidad),
              tel_celular: reemplazarIndefinido(valor.leg_celular),
              email: reemplazarIndefinido(valor.leg_mail),
            };

            if (tipo === "alta" && commonData.ingreso.includes(mesanio)) {
              lista.push(commonData);
            }
            if (tipo === "baja" && commonData.egreso !== '-' && commonData.egreso.includes(mesanio)) {
              lista.push(commonData);
            }
          });
        };

        processPersonalData(personal.data, "Food Service America");
        processPersonalData(personal_cat.data, "Food Service Catering");

        this.personal = lista;
      } catch (err) {
        console.error("Error fetching personal data:", err);
        alert('Error al cargar el personal.');
      } finally {
        this.triggers.load = false;
        this.$nextTick(() => {
          $('#empresas').DataTable({
            language: {
              decimal: ",", thousands: ".",
              info: "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
              infoEmpty: "Mostrando registros del 0 al 0 de un total de 0 registros",
              infoFiltered: "(filtrado de un total de _MAX_ registros)",
              loadingRecords: "Cargando...",
              lengthMenu: "Mostrar _MENU_ registros",
              paginate: { first: "Primero", last: "Último", next: "Siguiente", previous: "Anterior" },
              processing: "Procesando...",
              search: "Buscar:", searchPlaceholder: "Término de búsqueda",
              zeroRecords: "No se encontraron resultados",
              emptyTable: "Ningún dato disponible en esta tabla"
            },
            scrollX: false,
            search: { regex: true },
            dom: 'Bfrtip',
            responsive: false,
            nowrap: false,
            buttons: ['copy','excel','csv','pdf']
          });
        });
      }
    },
    refrescarPersonal(seReasigno) {
      this.modalAdministrar.open = false;
      this.modalLegales.open = false;
      this.modalObservar.open = false;
      this.modalVacunas.open = false;
      if (seReasigno) {
        // DataTables destroy is now handled at the beginning of obtenerPersonal
        this.obtenerPersonal();
      }
    },
    async getLegajo(legajo) {
      // Destroy DataTable for novedades_legajo if it exists
      if ($.fn.DataTable.isDataTable('#novedades_legajo')) {
        $('#novedades_legajo').DataTable().destroy();
      }

      // Find the personal details for the selected legajo
      const selectedPersonal = this.personal.find(p => p.legajo === legajo);
      if (selectedPersonal) {
          this.currentLegajoDetails = selectedPersonal;
      } else {
          console.warn("Personal details not found for legajo:", legajo);
          this.currentLegajoDetails = null; // Clear previous details if not found
          return; // Exit if no details found
      }

      $("#info_legajo").slideDown();

      this.novedades = [];
      this.triggers.load = true;

      const reqBase = axios.get(`https://auth.foodservice.com.ar/index_test.php?type=novedades_legajo&legajo=${legajo}&access_token=1234567`);
      const reqUser = axios.get(`https://aplicativos.firebaseio.com/novedades_usuarios_test.json?orderBy="legajo"&equalTo=${legajo}&limitToLast=1000&print=pretty`);
      const reqHRBP = axios.get(`https://aplicativos.firebaseio.com/novedades_usuarios_test_hrbp.json?orderBy="legajo"&equalTo=${legajo}&limitToLast=1000&print=pretty`);

      try {
        const [resBase, resUser, resHRBP] = await axios.all([reqBase, reqUser, reqHRBP]);

        const procesa = dataObj => {
          Object.entries(dataObj || {}).forEach(([id, item]) => {
            // Filter out "Sin novedad" and "Franco" entries
            if (item.novedad === "Sin novedad" || item.novedad === "Franco"|| item.novedad === "Sabados NT") {
              return; // Skip this item
            }

            const desde = item.desde || '-';
            const hasta = item.hasta || '-';
            const horas = item.horas || '-';
            const status = item.status || '-';
            const obs = item.obs || 0; // Ensure obs is a number, default to 0
            const cert = item.certificado || '-';
            // Corrected calculation for days: milliseconds / (1000ms/s * 60s/min * 60min/hr * 24hr/day)
            const diffMs = moment(hasta, "YYYY-MM-DD").diff(moment(desde, "YYYY-MM-DD"));
            const dias = isNaN(diffMs) ? '-' : Math.floor(diffMs / (1000 * 60 * 60 * 24)) + 1;
            console.log(cert)
            this.novedades.push({
              fireId: id,
              desde,
              hasta,
              horas,
              status,
              statusMensaje: status,
              detalle: item.detalle || '-',
              legajo: item.legajo,
              nombre: item.nombre,
              operacion_raiz: item.operacion_raiz || '-', // Ensure operacion_raiz is included
              novedad: item.novedad,
              responsable: item.responsable,
              responsable_dni: item.responsable_dni,
              fecha: item.fecha,
              fecha_novedad: item.fecha_novedad,
              obs: obs, // Use the parsed obs value
              noti: item.noti ? '1' : '0',
              certificado: cert,
              dias,
              observacion: item.observacion // Keep the nested observation object if it exists
            });
          });
        };

        procesa(resBase.data);
        procesa(resUser.data);
        procesa(resHRBP.data);

      } catch (err) {
        console.error(err);
        alert('Error al cargar novedades');
      } finally {
        this.triggers.load = false;
        this.$nextTick(() => {
          $('#novedades_legajo').DataTable({
            language: {
              decimal: ",", thousands: ".",
              info: "Mostrando _START_ a _END_ de _TOTAL_ regs",
              infoEmpty: "Mostrando 0 a 0 de 0 regs",
              infoFiltered: "(filtrado de _MAX_)",
              loadingRecords: "Cargando...", lengthMenu: "Mostrar _MENU_", zeroRecords: "No hay resultados",
              paginate:{ first:"Primero", last:"Último", next:"Siguiente", previous:"Anterior" },
              search:"Buscar:", searchPlaceholder:"Término de búsqueda"
            },
            scrollX: false,
            search: { regex: true },
            dom: 'Bfrtip',
            responsive: false,
            nowrap: false,
            buttons: ['excel','csv'],
            order: [[7,'desc']]
          });
        });
      }
    },
    obtenerFechasDelRango(mes, anio) {
      let d = anio + "-" + mes + "-01";
      let check = moment(d, "YYYY-MM-DD"); // Use YYYY-MM-DD for consistency
      let diasmes = moment(d, "YYYY-MM-DD").daysInMonth();
      let month = check.format("MM");
      let year = check.format("YYYY");
      let nfe = year + "-" + month + "-01";
      let nfs = year + "-" + month + "-" + diasmes;
      let beforeSevenDays = moment(nfe).format("YYYY-MM-DD");
      let hoy = moment(nfs).format("YYYY-MM-DD");
      let inicio = moment(beforeSevenDays).format();
      return [inicio, hoy];
    }
  },
  mounted() {
    // Initialize with current month/year data
    this.obtenerPersonal();
  },
  beforeMount() {
    let today = moment();
    let year = today.format("YYYY");
    for (let x = parseInt(year); x >= 2018; x--) {
      this.anios.push(x);
    }
  }
};
</script>

<style scoped>
.fila-no-distribuido {
  background: radial-gradient(#ff00001a, transparent 91%);
}
.observacion-existente {
  background: #10b759;
  border-radius: 50%;
  padding: 3px 4px;
  width: 16px;
  height: 16px;
  position: absolute;
  transform: translate(60px, -20px);
}
#info_legajo {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: #fff;
  z-index: 9999999;
  padding: 40px;
  left: 0;
  top: 0;
  display: none; /* Controlled by Vue's :style binding */
}
#info_legajo td {
  border: 1px solid #ccc;
}
#legajo_foto {
  width: 300px;
  height: 300px;
  background-color: #ccc;
  display: flex; /* Added for centering image */
  align-items: center; /* Added for centering image */
  justify-content: center; /* Added for centering image */
  overflow: hidden; /* Added to ensure image fits */
  border-radius: 50%; /* Added for circular image */
}
#legajo_foto img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%; /* Ensure image itself is circular */
}
.circulo {
  width: 100px;
  height: 100px;
  background: #b7b5b5;
  border-radius: 50%;
  display: flex; /* Added for centering text */
  align-items: center; /* Added for centering text */
  justify-content: center; /* Added for centering text */
  font-weight: bold; /* Added for text visibility */
}
#novedades_legajo td {
  font-size: 10px;
}
#header_legajo {
  width: 100%;
  background-color: #7e86ed;
  height: 37px;
  position: fixed;
  left: 0;
  top: 0;
}

/* Styles for badges - based on common badge colors */
.badge {
  display: inline-block;
  padding: .25em .4em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: .25rem;
  text-transform: uppercase; /* From original code */
}
.badge-warning {
  color: #212529;
  background-color: #ffc107;
}
.badge-success {
  color: #fff;
  background-color: #28a745;
}
.badge-info {
  color: #fff;
  background-color: #17a2b8;
}
.badge-danger {
  color: #fff;
  background-color: #dc3545;
}

/* Styles for the new observation modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999999;
}

.modal-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-width: 500px;
  width: 90%;
}

.modal-title {
  font-size: 1.25rem; /* Equivalent to text-xl */
  font-weight: bold;
  margin-bottom: 1rem;
}

.modal-body {
  margin-bottom: 1rem;
  color: #4a5568; /* Equivalent to text-gray-700 */
}

/* Basic button styles for the modal, matching original btn-danger */
.btn {
  display: inline-block;
  font-weight: 400;
  color: #212529;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: .375rem .75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: .25rem;
  transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}
.btn-danger {
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
}
.btn-danger:hover {
  color: #fff;
  background-color: #c82333;
  border-color: #bd2130;
}
</style>